import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=1a01a657&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=1a01a657&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a01a657",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a01a657')) {
      api.createRecord('1a01a657', component.options)
    } else {
      api.reload('1a01a657', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=1a01a657&scoped=true", function () {
      api.rerender('1a01a657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/PageHeader/PageHeader.vue"
export default component.exports